export const NEWS_TYPE = {
  MEDIA: 1,
  ACTIVITY: 2,
  TREND: 3,
  LATEST: 4,
};

export const NEWS_TYPE_CONFIG = {
  [NEWS_TYPE.MEDIA]: {
    id: NEWS_TYPE.MEDIA,
    key: "media",
    label: "nav.media",
    route: "/news/media",
  },
  [NEWS_TYPE.ACTIVITY]: {
    id: NEWS_TYPE.ACTIVITY,
    key: "activity",
    label: "nav.activity",
    route: "/news/activity",
  },
  [NEWS_TYPE.TREND]: {
    id: NEWS_TYPE.TREND,
    key: "trend",
    label: "nav.trend",
    route: "/news/trend",
  },
  [NEWS_TYPE.LATEST]: {
    id: NEWS_TYPE.LATEST,
    key: "latest",
    label: "nav.latest",
    route: "/news/latest",
  },
};

export const NEWS_TYPE_LIST = Object.values(NEWS_TYPE_CONFIG);

export const NEWS_TYPE_ID_MAP = NEWS_TYPE_LIST.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

export const NEWS_TYPE_KEY_MAP = NEWS_TYPE_LIST.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

export const NEWS_TYPE_LABEL_MAP = NEWS_TYPE_LIST.reduce((acc, item) => {
  acc[item.label] = item;
  return acc;
}, {});

export const getNewsTypeConfigById = (id) =>
  NEWS_TYPE_ID_MAP[id] || NEWS_TYPE_ID_MAP[NEWS_TYPE.LATEST];
